import {
  Divider,
  DialogContent,
  Dialog,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from '@mui/material';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { useSearch } from '@app/hooks';
import { CustomAvatar } from '@app/components';
import { IOverdueTasks } from '../type';

interface Props {
  open: boolean;
  onClose: VoidFunction;
  onSelectAssignee: (member: any) => void;
  data: any;
  setSelectedAssignee?: any;
}

const SelectAssignee = ({ open, onClose, onSelectAssignee, data, setSelectedAssignee }: Props) => {
  const processedData = data.map((task: IOverdueTasks) => ({
    ...task,
    searchableAssignee: `${task.assignee.firstName} ${task.assignee.lastName}`.toLowerCase(),
  }));
  const uniqueAssignees = processedData.filter(
    (task: IOverdueTasks, index: number, self: IOverdueTasks[]) =>
      self.findIndex((t: any) => t.assignee.id === task.assignee.id) === index
  );
  const searchProps = useSearch({
    data: uniqueAssignees,
    fields: ['searchableAssignee'],
  });
  return (
    <Dialog open={open} onClose={onClose}>
      <Header
        variant="dialog"
        title={'Select Assignee'}
        onClose={onClose}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <Divider />
      <DialogContent>
        {searchProps.filteredRows && searchProps.filteredRows?.length > 0 ? (
          <List>
            {searchProps.filteredRows.map((member: IOverdueTasks) => (
              <ListItem
                key={member.assignee.id}
                onClick={() => {
                  setSelectedAssignee(member.assignee);
                  onSelectAssignee(member.assignee.firstName);
                  onClose();
                }}
              >
                <ListItemIcon>
                  <CustomAvatar
                    name={`${member.assignee.firstName} ${member.assignee.lastName}`}
                    color="info"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={`${member.assignee.firstName} ${member.assignee.lastName}`}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body1" sx={{ textAlign: 'center', padding: 2 }}>
            {Strings.taskBoard.noAssigneeFound}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SelectAssignee;
